module.exports = __webpack_public_path__ + "static/media/houston_icon.4e22eb84.svg";